module.exports = __webpack_public_path__ + "img/questionnaire-torquoise-shape-left.1db17da1.svg";